import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  BusinessMessageTemplates: [],
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,
};

export const fetchBusinessMessageTemplate = createAsyncThunk(
  "/TemplateMessage/fetchBusinessMessageTemplate",
  async ({ businessId, module }) => {
    const response = await axiosInstanceAuth.get(
      `/TemplateMessage/GetBusinessMessageTemplate?businessId=${businessId}&module=${module}`
    );
    return response.data;
  }
);

const MessageAutomationSlice = createSlice({
  name: "MessageAutomation",
  initialState,
  reducers: {
    MessageAutomationAdded: {
      reducer(state, action) {
        state.BusinessMessageTemplates?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchBusinessMessageTemplate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBusinessMessageTemplate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload?.Message;
        state.isSuccess = action.payload?.IsSuccess;
        state.BusinessMessageTemplates = action.payload?.Data;
      })
      .addCase(fetchBusinessMessageTemplate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const getMessageAutomationDetails = (state) => state.MessageAutomation;

export const { MessageAutomationAdded } = MessageAutomationSlice.actions;

export default MessageAutomationSlice.reducer;
